import { createFileRoute } from '@tanstack/react-router';
import { Schema } from 'effect';
import { PcmPage } from '../../../pcm/pcm-page.tsx';
import { PcmSearch, pcmLinkOf, pcmSearchOf, withEcosystem } from '../../../pcm/route/pcm-tabs.ts';
import type { PcmLink } from '../../../pcm/route/pcm-tabs.ts';
import { InvalidLinkPage } from '../../search/invalid-link-page.tsx';

// Declared inline: the route plugin splits `component` and `errorComponent` into lazy bindings it
// declares after the options. The URL tests mount `Route.options` in a memory router.
export const Route = createFileRoute('/pcm/')({
  validateSearch: Schema.toStandardSchemaV1(PcmSearch),
  component: PcmRoute,
  errorComponent: InvalidLinkPage,
});

// Another ecosystem or another tab is another view: each gets its own history entry.
function PcmRoute(): JSX.Element {
  const navigate = Route.useNavigate();
  const link = pcmLinkOf(Route.useSearch());
  const open = (next: PcmLink): void => {
    void navigate({ search: pcmSearchOf(next) });
  };
  return (
    <PcmPage
      ecosystem={link.ecosystem}
      onEcosystem={(ecosystem) => {
        open(withEcosystem(link, ecosystem));
      }}
      onTab={(tab) => {
        open({ ...link, tab });
      }}
      tab={link.tab}
    />
  );
}
